<template>
  <div class="container relative flex justify-between items-center mx-auto px-8 md:px-14 lg:px-24 w-full"
        data-aos="fade-right" data-aos-duration="1000">
        <section class="w-full">
            <div class="circle circle-3 hidden md:block absolute z-1"></div>
            <h2 class="secondary-title" id="archievement">Archievement</h2>
            <p class="section-paragraph text-white">
                I got achievements during become a programmer.
            </p>
            <!-- archievement logo -->
            <div class="space-y-12 my-16" data-aos="fade-right" data-aos-duration="1000">
                <div class="w-full flex flex-col md:flex-row border p-16 lg:px-32 lg:py-20 lg:space-x-32 bg-body">
                    <!-- archievement logo -->
                    <div class="mb-6 lg-mb-0">
                        <img src="../assets/img/lks.webp" alt="">
                    </div>
                    <!-- archievement info -->
                    <div class="flex flex-wrap justify-center text-center lg:text-left lg:block">
                        <h3 class="text-white text-3xl font-semibold">1st Winner of LKS Wilker</h3>
                        <div class="w-full lg:w-auto flex flex-wrap justify-center lg:justify-start gap-3 mt-6 mb-8">
                            <div class="badge">AI</div>
                            <div class="bagde mt-1">Artificial Intelegent</div>
                        </div>
                        <p class="text-secondary mb-4">1st place in the LKS wilker race in the field of artificial
                            intelligence competition in 2022</p>
                        <a href="https://drive.google.com/file/d/1v1Yrcw4Jndd01qo6HzCnJz8FhKXEPcSG/view?usp=sharing"
                            target="_blank"
                            class="border-2 rounded-full font-bold py-2 px-4 mt-10 hover:bg-white hover:text-black">view
                            sertificate</a>
                    </div>
                </div>
            </div>
            <div class="space-y-12 my-16" data-aos="fade-left" data-aos-duration="1000">
                <div class="w-full flex flex-col md:flex-row border p-16 lg:px-32 lg:py-20 lg:space-x-32 bg-body">
                    <!-- archievement logo -->
                    <div class="mb-6 lg-mb-0 w-full md:w-1/2">
                        <img src="../assets/img/dinacom.webp">
                    </div>
                    <!-- archievement info -->
                    <div class="w-full flex flex-wrap justify-center text-center lg:text-left lg:block">
                        <h3 class="text-white text-3xl font-semibold">1st Dinacom</h3>
                        <div class="w-full lg:w-auto flex flex-wrap justify-center lg:justify-start gap-3 mt-6 mb-8">
                            <div class="badge">APPS</div>
                        </div>
                        <p class="text-secondary mb-4">1st place in the race held by Dinacom in the field of app
                            development
                        </p>
                        <a href="https://drive.google.com/file/d/1mo1VCPlxATCxWcR1oV5KCva9eOG9RZcD/view?usp=sharing"
                            target="_blank"
                            class="border-2 rounded-full font-bold py-2 px-4 mt-10 hover:bg-white hover:text-black">view
                            sertificate</a>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
  name: "Archievements",
};
</script>